import { css } from '@emotion/core';
import { ICustomTheme, Responsive } from '@/ui';

export function getHeadingStyle(
	theme: ICustomTheme,
	level: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
) {
	const heading = theme.typography?.header?.[level];
	const mobile = theme.typography?.mobile?.header?.[level];

	if (!heading || !mobile) {
		return undefined;
	}

	return css`
		font-size: ${heading.size};
		color: ${heading.color};
		font-weight: ${heading.fontWeight};
		font-family: ${heading.fontFamily};

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			font-size: ${mobile.size};
		}
	`;
}
